import { DatePicker } from "@mui/x-date-pickers";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Button,
} from "@mui/material";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { SUBSCRIPTION_TYPE } from "static/patients_reminder";
import { Formik } from "formik";
import SubmitButton from "components/Button/SubmitButton";
import { TwilioPatientFilterSchema } from "schemas/TwilioPatientFilterSchema";
import { CURRENT_DATE } from "static/constants";
import { getFormattedDate } from "utils/date";
import dayjs from "dayjs";
import { DATE_FORMAT } from "static/date";

const ReminderPatientModal = ({
  isModalOpen,
  onClose,
  onDownload,
  disabled,
}) => {
  const minDate = new Date("2023-01-01");

  return (
    <ModalWrapper
      title={
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column">
            <h3>Reminder Patients</h3>

            <div
              style={{
                fontSize: "14px",
                fontWeight: "400",
                marginTop: "4px",
              }}
            >
              Generate a list of patients based on the selected reminder type
              and date range.
            </div>
          </div>
        </div>
      }
      show={isModalOpen}
      onClose={onClose}
    >
      <Formik
        enableReinitialize
        initialValues={{
          type: "",
          startDate: null,
          endDate: null,
        }}
        validationSchema={TwilioPatientFilterSchema}
        onSubmit={(values) => onDownload(values)}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({
          values,
          errors,
          setFieldValue,
          touched,
          handleSubmit,
          isSubmitting,
        }) => (
          <div className="d-flex flex-column" style={{ gap: 15 }}>
            <div>
              <FormControl fullWidth>
                <InputLabel id="issue-label">Select Type</InputLabel>
                <Select
                  id="type"
                  label="Select Type"
                  value={values?.type}
                  onChange={(event) =>
                    setFieldValue("type", event.target.value)
                  }
                  error={touched?.type && !!errors?.type}
                >
                  {SUBSCRIPTION_TYPE?.map(({ value, label }, index) => (
                    <MenuItem key={index} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {touched?.type && errors?.type && (
                <FormHelperText error>{errors?.type}</FormHelperText>
              )}
            </div>
            <div style={{ display: "flex" }}>
              <FormControl fullWidth variant="outlined">
                <DatePicker
                  margin="none"
                  id="billing_history_start"
                  label="Start Date"
                  inputVariant="outlined"
                  value={values?.startDate ? dayjs(values?.startDate) : null}
                  KeyboardButtonProps={{
                    "aria-label": "pick date",
                  }}
                  format={DATE_FORMAT.DEFAULT}
                  autoOk
                  onChange={(date) =>
                    setFieldValue("startDate", getFormattedDate(date))
                  }
                  minDate={dayjs(minDate)}
                  maxDate={dayjs(CURRENT_DATE)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: touched?.startDate && !!errors?.startDate,
                      helperText: touched?.startDate && errors?.startDate,
                    },
                  }}
                />
              </FormControl>
              <FormControl
                style={{ marginLeft: "10px" }}
                fullWidth
                variant="outlined"
              >
                <DatePicker
                  margin="none"
                  id="billing_history_start"
                  label="End Date"
                  inputVariant="outlined"
                  format={DATE_FORMAT.DEFAULT}
                  value={values?.endDate ? dayjs(values?.endDate) : null}
                  KeyboardButtonProps={{
                    "aria-label": "pick date",
                  }}
                  autoOk
                  onChange={(date) => {
                    setFieldValue("endDate", getFormattedDate(date));
                  }}
                  minDate={dayjs(minDate)}
                  maxDate={dayjs(CURRENT_DATE)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: touched?.endDate && !!errors?.endDate,
                      helperText: touched?.endDate && errors?.endDate,
                    },
                  }}
                />
              </FormControl>
            </div>
            <div className="view-pdf__button-container">
              <Button
                onClick={onClose}
                className="view-pdf__button"
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
              <SubmitButton
                className="view-pdf__button"
                disabled={disabled}
                buttonText={isSubmitting ? "Downloading..." : "Download"}
                onClick={handleSubmit}
                isLoading={isSubmitting}
              />
            </div>
          </div>
        )}
      </Formik>
    </ModalWrapper>
  );
};

export default ReminderPatientModal;
